import { AcceptRejectProviderItemPayload } from '@/queries/providers/requests'

/**
 * Provider item review status. `Pending` items have never been reviewed, which
 * is why both decisions are offered on them.
 */
export const PROVIDER_ITEM_STATUS = {
  PENDING: 0,
  ACCEPTED: 1,
  REJECTED: 2,
} as const

export type AcceptRejectProviderItemParams = {
  providerId: number
  itemId: number
  programId: number
} & AcceptRejectProviderItemPayload
